import { Action } from 'redux';

import { isGetCredentialEncryptionKeyRequest, isGetCredentialEncryptionKeyRequestSucceeded } from '../actions/GetCredentialEncryptionKeyRequestAction';
import { ICredentialEncryptionInfo } from '../models/CredentialEncryptionModels';

const InitialState: ICredentialEncryptionInfo = {
    encryptionKey: undefined,
    isFetchingEncryptionKey: false,
};

export function CredentialEncryptionReducer(
  previousState: ICredentialEncryptionInfo= InitialState,
  action: Action
): ICredentialEncryptionInfo {
    if(isGetCredentialEncryptionKeyRequest(action)){
        return {
            ...previousState,
            isFetchingEncryptionKey: true
        };
    }
    else if (isGetCredentialEncryptionKeyRequestSucceeded(action)) {
        return {
            ...previousState,
            encryptionKey: (action as any)?.encryptionKey ?? undefined,
            isFetchingEncryptionKey: false
        };
    }
    return previousState;
}